import { update, postInfo, getInfo } from '@/utils/apiBase.js';

// 获取全部发货操作记录
export const QueryEewardAllDeliverRecord = (option) => {
  return getInfo('/apis/mdlogistics/order/query_reward_all_deliver_record', option);
};
// 上传文件
export const xlsxUpload = (option) => {
  return update('/apis/xlsx/upload', option, {
    'Content-Type': 'multipart/form-data',
  });
};
// 批量上传发货
export const mdlogisticsOrderDeliver = (option) => {
  return postInfo('/apis/mdlogistics/order/deliver', option);
};
// 按回报档发货
export const rewardAllDeliver = (option) => {
  return postInfo('/apis/mdlogistics/order/reward_all_deliver', option);
};
// 按订单发货
export const batch_modify_deliver_status_check = (option) => {
  return postInfo(
    '/apis/mdlogistics/order/batch_modify_deliver_status_check',
    option
  );
};
// 按订单确认发货
export const batch_modify_deliver_status_exec = (option) => {
  return postInfo(
    '/apis/mdlogistics/order/batch_modify_deliver_status_exec',
    option
  );
};
// 检测订单发货
export const query_batch_modify_deliver_status = (option) => {
  return getInfo(
    '/apis/mdlogistics/order/query_batch_modify_deliver_status',
    option
  );
};

// 检测批量上传发货
export const orderQueryDeliver = (option) => {
  return getInfo('/apis/mdlogistics/order/query_deliver', option);
};
// 检测按回报档确认发货
export const queryRewardAllDeliver = (option) => {
  return getInfo('/apis/mdlogistics/order/query_reward_all_deliver', option);
};
// cp发货单明细下载
export const deliverDownload = (option) => {
  return getInfo('/apis/mdcporder/order/deliver_download', option);
};
// cp发货单明细下载erp
export const deliverDownloadErp = (option) => {
  return getInfo('/apis/mdcporder/order/deliver_download_erp', option);
};
// 检测cp发货单明细下载
export const queryDeliverDownload = (option) => {
  return getInfo('/apis/mdcporder/order/query_deliver_download', option);
};

export default {
  QueryEewardAllDeliverRecord,
  xlsxUpload,
  mdlogisticsOrderDeliver,
  orderQueryDeliver,
  rewardAllDeliver,
  queryRewardAllDeliver,
  batch_modify_deliver_status_check,
  query_batch_modify_deliver_status,
  batch_modify_deliver_status_exec,
  deliverDownload,
  queryDeliverDownload,
  deliverDownloadErp
};
